import { Parchment } from 'quill/core';

const ID_LENGTH = 4;
const ID_PREFIX = 'h';
const ID_REGEX = new RegExp(`^${ID_PREFIX}[0-9a-z]{${ID_LENGTH}}-`);

export const generateHeaderId = () => {
  return `${ID_PREFIX}${Math.random()
    .toString(36)
    .substring(2, 2 + ID_LENGTH)}`;
};

export const parseHeaderId = (fragment: string) => {
  if (fragment.match(ID_REGEX)) {
    const [id] = fragment.split('-', 2);
    return id;
  }
  return null;
};

class HeaderId extends Parchment.Attributor {
  constructor(attrName = 'header-id', keyName = 'header-id') {
    super(attrName, keyName, { scope: Parchment.Scope.BLOCK });
  }
}

export default new HeaderId();
